export default __webpack_public_path__ + "static/media/disaster-recovery.313a397b.svg";